import React, { useEffect, useState } from "react";
import "./styles.scss";
import { CategoryCard, FormHeader } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { CreateNewCategory } from "../CreateNewItem";
import { getAllCategory } from "../CreateNewItem/CreateNewCategory/service/category.service";
import { setCategory, setCategoryList } from "./redux/actions";
import { getLanguage } from "../../utils/environment";

const lan = getLanguage();
const Category = () => {
  const dispatch = useDispatch();
  // const selectedCategory = useSelector(
  //   (state) => state.categoryReducer.selectCategory
  // );
  // const [categoryList, setCategoryList] = useState([]);
  const categoryList = useSelector(
    (state) => state.categoryReducer.categoryList
  );
  const [selectCategory, setSelectCategory] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getCategory = await getAllCategory();
        console.log("Get All Category : ", getCategory);

        if (getCategory.data) {
          dispatch(setCategoryList(getCategory.data));
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Category", error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <div className="hne-category-wrapper">
        <div className="col-9 category-body-wrapper">
          <FormHeader
            data={{
              formHeader: "Categories",
              size: "md-md",
            }}
          />
          <div className="hne-sub-header-wrapper">
            <div className="shw-id">Id</div>
            {lan === "si" && <div className="shw-si">name - (SI)</div>}
            <div className="shw-si">name - (EN)</div>
          </div>
          <div className="hne-body-wrapper">
            {Array.isArray(categoryList) && categoryList.length > 0 ? (
              categoryList.map((category) => (
                <CategoryCard
                  isSelect={selectCategory === category?.category_id}
                  id={category.category_id}
                  nameSI={category.name?.si}
                  nameEN={category.name?.en}
                  edit="Edit"
                  onClick={() => {
                    setSelectCategory(category?.category_id);
                    dispatch(setCategory(category));
                  }}
                />
              ))
            ) : (
              <div className="error-message">No Category Found</div>
            )}
            {/* <CategoryCard
              id={"02"}
              nameSI={""}
              nameEN={"Business News"}
              edit={"Edit"}
              onClick={() => {}}
            /> */}
          </div>
        </div>

        {/*right side*/}
        <div className="col-3 category-right-side-wrapper">
          <CreateNewCategory />
        </div>
      </div>
    </>
  );
};
export default withRouter(Category);
